:root {
  --red: #DF0A0A;
  --naval-blue: #3959D9;
  --green-sheets: #538504;
  --purple: #6434F4;
}

.red {
  color: var(--red);
}

.naval-blue {
  color: var(--naval-blue);
}

.green-sheets {
  color: var(--green-sheets);
}

.purple {
  color: var(--purple);
}

.gap-2rem {
  gap: 2rem;
}

.arial {
  font-family: Arial, sans-serif;
}

.text-ellipsis-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text-ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.content-text {
  &.column {
    column-count: 2;
    column-gap: 2rem;

    @media screen and (max-width: 768px) {
      column-count: 1;
    }
  }

  ul li {
    list-style-type: square;
  }
}

.content-text * {
  line-height: 1.75;
}

.text-balance {
  text-wrap: balance;
}

.text-sml,
.small,
.text-small {
  font-size: 13px !important;
}

.fs-inherit {
  font-size: inherit !important;
}

.fs-initial {
  font-size: initial !important;
}

p * {
  font-size: inherit !important;
  color: inherit !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.outline-none {
  outline: none !important;
  box-shadow: none !important;
}

.pv-05 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}

.pv-15 {
  padding-top: 0.35rem !important;
  padding-bottom: 0.45rem !important;
}

.w-15 {
  width: 15% !important;
}

.w-10 {
  width: 10% !important;
}
